import _ from 'lodash'
import Translate from 'utils/translate'
import ObjectBooking from 'utils/objects/booking'
import Timeslot from 'components/molecules/Timeslot'
import SelectLunch from 'components/molecules/SelectLunch'
import React from 'react'

const LunchOption = ({ item, employee, onSelect }) => {
	const { building, floor, room } = item;
	
	const timeTimeslot = ObjectBooking.getTimeSlot( item );
	
	const title = _.filter([
		Translate.field( floor, 'title' ),
		Translate.field( room, 'title' ),
	]);
	
	return (
		<Timeslot
			item={{
				...item,
				employee: employee
			}}
			timeFrom={ _.get( timeTimeslot, 0, null ) }
			timeTill={ _.get( timeTimeslot, 1, null ) }
			title={ title.join(' - ') }>
			
			<SelectLunch
				item={ item }
				building={ building }
				floor={ floor }
				room={ room }
				select={ onSelect.bind( this, employee ) }
				selected={ _.get( item.selectedLunchOption, employee.guid, null ) }
			/>
		</Timeslot>
	);
}

export default LunchOption
